import { render, staticRenderFns } from "./pic_com.vue?vue&type=template&id=6e0e20ca&scoped=true"
import script from "./pic_com.vue?vue&type=script&lang=js"
export * from "./pic_com.vue?vue&type=script&lang=js"
import style0 from "./pic_com.vue?vue&type=style&index=0&id=6e0e20ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e20ca",
  null
  
)

export default component.exports